import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';

import CustomAlert from 'components/shared/CustomAlert/CustomAlert';
import CustomAlertContain from 'components/shared/CustomAlert/CustomAlertContain';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomCheckbox from 'components/shared/CustomCheckbox/CustomCheckbox';
import CustomPopOver from 'components/shared/CustomPopOver/CustomPopOver';
import CustomSearch from 'components/shared/CustomSearch/CustomSearch';
import { LightTooltip } from 'components/shared/CustomTooltip/CustomTooltip';
import { ZoomInfoService } from 'service/zoominfo.service';
import zeplinColor from 'theme/Color';
import { Utilities } from 'utilities/utilities';
import Card from './Card';
import Chart from './Chart';
import styles from './styles.module.css';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
    },
  },
};
const Employees = () => {
  const location = useLocation();
  const [selected, setSelected] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [departmentData, setDepartmentData] = useState<any[]>([]);
  const [page, setPage] = useState({ current: 1, total: 1 });

  const [error, setError] = useState(false);
  const [selectedItems, setSelectedItems] = useState<{
    jobTitle: string[];

    department: string[];
  }>({
    jobTitle: [],

    department: [],
  });
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [filterOption, setFilterOption] = useState<any>();
  const getCompanyEmployees = async (id = '', query: any, refresh = false, init = false) => {
    try {
      console.log('next @@@');
      setLoading(true);
      const res = await ZoomInfoService.getCompanyEmployees(
        id,
        refresh ? '1' : page?.current?.toString(),
        { includeFilters: true, ...query },
      );

      console.log(res);
      setData((prev) => (refresh || init ? [...res?.data?.items] : [...prev, ...res?.data?.items]));
      setFilteredData((prev) =>
        refresh || init ? [...res?.data?.items] : [...prev, ...res?.data?.items],
      );
      setDepartmentData(res?.data?.departments);
      setFilterOption(res?.data?.filterOptions);
      setPage((prev) => ({
        current: refresh ? 1 : prev.current + 1,
        total: res?.data?.totalPages,
      }));
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const handleClose = () => {
    setError(false);
  };

  const handleSelection = (item: any, type: string) => {
    const key = type as keyof typeof selectedItems;

    const {
      target: { value },
    } = item;

    setSelectedItems({
      ...selectedItems,
      [key]: typeof value === 'string' ? value.split(',') : value,
    });
  };
  const handleClearAll = () => {
    setSelectedItems({
      jobTitle: [],

      department: [],
    });
    getCompanyEmployees(location?.pathname.split('/')[2] || '', {});
    setAnchorEl(null);
  };
  const applyFilter = async () => {
    console.log('filter', selectedItems);
    getCompanyEmployees(
      location?.pathname.split('/')[2] || '',
      {
        title: selectedItems?.jobTitle?.join(','),
        department: selectedItems?.department?.join(','),
      },
      true,
    );
    setAnchorEl(null);
  };
  const exportContact = async () => {
    try {
      const payload =
        data?.length && selected?.length !== data?.length
          ? {
              contactIds: selected,
            }
          : {};
      const res = await ZoomInfoService.exportContacts(
        location?.pathname.split('/')[2] || '',
        payload,
      );
      Utilities.downloadCSV(res, 'Contact details');
    } catch (err) {
      setError(true);
    }
  };
  useEffect(() => {
    getCompanyEmployees(location?.pathname.split('/')[2] || '', {}, false, true);
  }, []);

  console.log({ loading, data, filteredData, page });
  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 330px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 2,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
            overflowY: 'scroll',
          }}
        >
          <Typography variant='responsiveHeading3'>All Contacts ({data?.length || 0})</Typography>
          <Box
            sx={{
              borderRadius: '14px 14px 0px 0px',
              border: `1px solid ${zeplinColor.Neutral5}`,
              flex: 1,
              overflowY: 'scroll',
              backgroundColor: zeplinColor.Neutral1,
            }}
          >
            <Box
              sx={{ position: 'sticky', top: 0, backgroundColor: zeplinColor.Neutral1, zIndex: 1 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '16px',
                }}
              >
                <CustomCheckbox
                  label='Select all'
                  checked={(data?.length && selected?.length === data?.length) || false}
                  onChange={(checked) => {
                    const details = data?.map((val) => val?.id?.toString());
                    setSelected((prev) => (selected?.length === data?.length ? [] : [...details]));
                    selected?.length === data?.length && setData(filteredData);
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    gap: '12px',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'flex-end',
                  }}
                >
                  {selected?.length ? (
                    <>
                      <Box
                        sx={{
                          padding: '6px 16px',
                          borderRadius: '8px',
                          backgroundColor: zeplinColor.Brand1,
                          display: 'flex',
                          gap: '8px',
                          alignItems: 'center',
                        }}
                        onClick={exportContact}
                      >
                        <Typography variant='responsiveButtonSmall' color={zeplinColor.Neutral1}>
                          Export
                        </Typography>
                      </Box>
                      <a
                        href={`mailto:${data
                          ?.filter?.(
                            (val: any) => selected?.indexOf(val?.data?.[0].id?.toString()) > -1,
                          )
                          .map((val: any) => val?.data?.[0].email)
                          ?.join(',')}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setAnchorEl(null);
                        }}
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{ textDecoration: 'none' }}
                      >
                        <Box
                          sx={{
                            padding: '6px 16px',
                            borderRadius: '8px',
                            backgroundColor: zeplinColor.Brand1,
                            display: 'flex',
                            gap: '8px',
                            alignItems: 'center',
                          }}
                        >
                          <Typography variant='responsiveButtonSmall' color={zeplinColor.Neutral1}>
                            Email
                          </Typography>
                        </Box>
                      </a>
                    </>
                  ) : (
                    <>
                      <CustomSearch
                        setProjects={() => {}}
                        getProjects={(text: string) => {
                          setData(
                            filteredData?.filter((val: any) => {
                              if (!text) {
                                return true;
                              }
                              return `${val?.data?.[0]?.firstName?.toLocaleLowerCase()} ${val?.data?.[0]?.lastName?.toLocaleLowerCase()}`?.includes(
                                text?.toLocaleLowerCase(),
                              );
                            }),
                          );
                        }}
                      />
                    </>
                  )}
                  <Box
                    sx={{
                      height: '32px',
                      width: '1px',
                      backgroundColor: zeplinColor.Neutral5,
                      display: 'inline-block',
                      marginX: '4px',
                    }}
                  />
                  <LightTooltip
                    title={
                      <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
                        Filter
                      </Typography>
                    }
                    placement='bottom-end'
                    style={{ backgroundColor: zeplinColor.BasicBlack, borderRadius: '8px' }}
                  >
                    <Box
                      className={styles.filterBox}
                      sx={{
                        border: `1px solid ${zeplinColor.Neutral6}`,
                        backgroundColor: zeplinColor.Neutral1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: zeplinColor.Neutral4,
                        },
                      }}
                      onClick={(e) => {
                        setAnchorEl(e.currentTarget);
                      }}
                    >
                      <img src={'/assets/filter.svg'} className={styles.icon} />
                    </Box>
                  </LightTooltip>
                </Box>
              </Box>
              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>

            <InfiniteScroll
              dataLength={data?.length || 0}
              loader={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <></>
                </Box>
              }
              next={() => {
                console.log('next');
                getCompanyEmployees(location?.pathname.split('/')[2] || '', {
                  title: selectedItems?.jobTitle?.join(','),
                  department: selectedItems?.department?.join(','),
                });
              }}
              hasMore={page?.current <= page?.total}
              height={'calc(100vh - 335px)'}
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                width: '100%',
              }}
            >
              {loading
                ? [1, 2, 3, 4, 5, 6, 7, 8].map((val) => (
                    <Card
                      setSelected={setSelected}
                      selected={selected}
                      key={val}
                      val={val}
                      loading={loading}
                      setError={setError}
                    />
                  ))
                : data?.map((val) => (
                    <Card
                      setSelected={setSelected}
                      selected={selected}
                      key={val?.id}
                      val={val}
                      loading={loading}
                      setError={setError}
                    />
                  ))}
            </InfiniteScroll>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 4,
            overflowY: 'scroll',
          }}
        >
          <Typography variant='responsiveHeading3'>Employees by Department</Typography>

          <Chart data={departmentData} loading={loading} />
        </Box>
        <Box
          sx={{
            flex: 1,
          }}
        ></Box>
      </Box>
      <CustomPopOver
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{
          borderRadius: '14px',
          boxShadow: 'rgba(0, 0, 0, 0.15)',
          marginTop: '8px',
          marginRight: '2rem',
          marginLeft: '-4rem',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              padding: '16px',
              width: { xs: '250px', xl: '283px' },
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              height: '100%',
              overflow: 'auto',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                Filter
              </Typography>
              <Typography
                variant='responsiveButtonSmall'
                color={
                  Object.values(selectedItems).every((val) => val.length <= 0)
                    ? zeplinColor.Neutral8
                    : zeplinColor.Brand1
                }
                onClick={
                  Object.values(selectedItems).every((val) => val.length <= 0)
                    ? () => {}
                    : handleClearAll
                }
                sx={{
                  cursor: Object.values(selectedItems).every((val) => val.length <= 0)
                    ? 'default'
                    : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                Clear All
              </Typography>
            </Box>

            {/* <div> */}
            <FormGroup
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' },
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Job Title
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.jobTitle}
                  onChange={(e) => handleSelection(e, 'jobTitle')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px',
                      }}
                      label='Record Types'
                    />
                  }
                  renderValue={(selected) => (selected as string[]).join(', ')}
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                  )}
                >
                  {filterOption?.jobTitles?.map((name: any) => (
                    <MenuItem
                      key={name.value}
                      value={name.value}
                      sx={{
                        fontSize: { xs: '12px', xl: '16px' },
                        padding: { xs: '6px 16px', xl: '8px 16px' },
                      }}
                    >
                      <Checkbox
                        checked={selectedItems.jobTitle.indexOf(name.value) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </FormGroup>
            <FormGroup
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
              }}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    fontSize: { xs: '14px', xl: '16px' },
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Department
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  multiple
                  value={selectedItems.department}
                  onChange={(e) => handleSelection(e, 'department')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                        padding: '0px 14px',
                      }}
                      label='Record Types'
                    />
                  }
                  renderValue={(selected) => (selected as string[]).join(', ')}
                  MenuProps={MenuProps}
                  IconComponent={() => (
                    <img src='/assets/down-arrow.svg' className={styles['icon-24']} />
                  )}
                >
                  {filterOption?.departments?.map((name: any) => (
                    <MenuItem
                      key={name.value}
                      value={name.value}
                      sx={{
                        fontSize: { xs: '12px', xl: '16px' },
                        padding: { xs: '6px 16px', xl: '8px 16px' },
                      }}
                    >
                      <Checkbox
                        checked={selectedItems.department.indexOf(name.value) > -1}
                        sx={{
                          color: zeplinColor.BasicBlack,
                          '&.Mui-checked': {
                            color: zeplinColor.BasicBlack,
                          },
                        }}
                      />
                      {name.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box sx={{ display: 'flex', alignItems: 'flex-end', flex: 1 }}>
                <CustomButton
                  onClick={applyFilter}
                  variant='contained'
                  disabled={Object.values(selectedItems).every((val) => val.length <= 0)}
                  color={'primary'}
                  style={{
                    width: '100%',
                    borderRadius: '14px',
                    height: { xs: '48px', md: '56px' },
                  }}
                  textStyle={{
                    color: Object.values(selectedItems).every((val) => val.length <= 0)
                      ? zeplinColor.Neutral8
                      : zeplinColor.Neutral1,
                    fontSize: { xs: '14px', xl: '16px' },
                  }}
                  text={'Apply'}
                />
              </Box>
            </FormGroup>
          </Box>
        </Box>
      </CustomPopOver>
      <CustomAlert
        open={error ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alert={error ? 'Something went wrong.' : ''}
            alertIcon={<img src='/assets/error.svg' width={24} height={24} />}
            error={error}
          />
        }
        error={error}
      />
    </Box>
  );
};

export default Employees;
